import { AsyncAction } from '../../types'
import { setOAuthError } from '../reducer'
import { increaseOAuthRejectionCounter, resetOAuthConsumerTags } from './api'
import { OAUTH_ACCESS_DENIED_ERROR } from '../../../model'

export const acceptOAuthConsent: AsyncAction<void> = async (dispatch) => {
  dispatch(setOAuthError(undefined))
  dispatch(resetOAuthConsumerTags())
}

export const declineOAuthConsent: AsyncAction<void> = async (dispatch) => {
  dispatch(setOAuthError(OAUTH_ACCESS_DENIED_ERROR))
  dispatch(increaseOAuthRejectionCounter())
}
